import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Close';
import CreateIcon from '@mui/icons-material/Create';
import DoneIcon from '@mui/icons-material/Done';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { toast } from 'react-toastify';

import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';
import colors from '@/main/style/colors';
import useAsyncModalConfirm from '@/main/components/shared/asyncModalConfirm/asyncModalConfirm';

import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import { procurementReportScheduleApi } from '@/main/api';
import { SpinnerLoading } from '@/main/components/shared/styles';
import { ProcurementReportScheduleGridResponse } from '@/main/models/response';
import { StatusProcurementReportScheduleEnum } from '@/main/services/enum/StatusProcurementReportSchedule';

import { IEditDataSchedule } from '../../../types';
import * as S from './styles';

interface IActionsReportScheduleProps {
  scheduleReport: ProcurementReportScheduleGridResponse;
  refreshGrid: () => void;
  updateDataEdit: (data: IEditDataSchedule) => void;
}
function ActionsReportSchedule({
  scheduleReport,
  refreshGrid,
  updateDataEdit
}: IActionsReportScheduleProps) {

  const [getConfirmation, ModalConfirmation] = useAsyncModalConfirm();
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoadingEdit, setIsLoadingEdit] = useState(false);

  function onClickEdit() {

    setIsLoadingEdit(true);

    if (isNullUndefined(scheduleReport.guidProcurementReportSchedule)) {
      toast.error(getTranslateByKey('information.somethingWrong', true));
      return;
    }

    procurementReportScheduleApi
      .getProcurementReportSchedule(scheduleReport.guidProcurementReportSchedule)
      .then(response => {
        const { result } = response.data;

        const mergedDataEdit = {
          ...result,
          ...scheduleReport
        };
        updateDataEdit(mergedDataEdit);
      })
      .finally(() => {
        setIsLoadingEdit(false);
      })

  }

  async function onClickCancel() {
    if (isNullUndefined(scheduleReport.guidProcurementReportSchedule)) {
      toast.error(getTranslateByKey('information.somethingWrong', true));
      return;
    }
    const result = await getConfirmation(getTranslateByKey("information.DoYouWantRemoSchedule"));


    if (result) {
      setIsLoadingDelete(true);

      procurementReportScheduleApi
        .removeProcurementReportSchedule(scheduleReport.guidProcurementReportSchedule)
        .then(() => {
          toast.success(getTranslateByKey('information.scheduleDeletedSucessfully'));
          refreshGrid();
        })
        .finally(() => {
          setIsLoadingDelete(false);
        })
    }
  }

  const ID_SCREEN = "id-report-schedule"
  const generateId = (action: string) => `${ID_SCREEN}-${action}`;
  const COLOR_CLOCK: Record<StatusProcurementReportScheduleEnum, string> = {
    [StatusProcurementReportScheduleEnum.Recurrent]: colors.green,
    [StatusProcurementReportScheduleEnum.Scheduled]: colors.yellow,
    [StatusProcurementReportScheduleEnum.Sent]: colors.green,
  };
  const TEXT_CLOCK: Record<StatusProcurementReportScheduleEnum, string> = {
    [StatusProcurementReportScheduleEnum.Recurrent]: getTranslateByKey("information.recurrentSchedule"),
    [StatusProcurementReportScheduleEnum.Scheduled]: getTranslateByKey("information.singleSchedule"),
    [StatusProcurementReportScheduleEnum.Sent]: getTranslateByKey("procurementReportScheduleStatus.Sent"),
  }
  const {
    idProcurementReportScheduleStatus
  } = scheduleReport;
  const MAP_BUTTONS_ACTIONS = [
    {
      id: generateId('btn-schedule'),
      icon: QueryBuilderIcon,
      color: COLOR_CLOCK[idProcurementReportScheduleStatus] ?? colors.yellow,
      tooltip: TEXT_CLOCK[idProcurementReportScheduleStatus] ?? getTranslateByKey('information.schedule'),
    },
    {
      id: generateId('btn-edit'),
      icon: CreateIcon,
      color: colors.icon,
      isLoading: isLoadingEdit,
      tooltip: getTranslateByKey('information.edit'),
      onClick: () => onClickEdit()
    },
    {
      id: generateId('btn-cancel'),
      icon: ClearIcon,
      color: colors.red,
      isLoading: isLoadingDelete,
      tooltip: getTranslateByKey('information.delete'),
      onClick: () => onClickCancel()
    }
  ]

  if (idProcurementReportScheduleStatus === StatusProcurementReportScheduleEnum.Sent) {
    return (
      <S.Container>
        <TooltipComponent
          placement='top'
          title={TEXT_CLOCK[idProcurementReportScheduleStatus] ?? getTranslateByKey('procurementReportScheduleStatus.Sent')}
        >
          <DoneIcon style={{ color: COLOR_CLOCK[idProcurementReportScheduleStatus] ?? colors.green }} />
        </TooltipComponent>
      </S.Container>
    )
  }

  return (
    <S.Container>
      {MAP_BUTTONS_ACTIONS.map((action) => (
        <React.Fragment key={action.id}>
          {action.isLoading ?
            <SpinnerLoading /> :
            <TooltipComponent
              key={action.id}
              placement='top'
              title={action.tooltip}
            >
              {isNullUndefined(action.onClick) ?
                <action.icon style={{ color: action.color }} /> :
                <IconButton
                  id={action.id}
                  disabled={action.isLoading}
                  onClick={action.onClick}
                >
                  <action.icon style={{ color: action.color }} />
                </IconButton>
              }
            </TooltipComponent>}
        </React.Fragment>
      ))}
      <ModalConfirmation />
    </S.Container>
  )
}

export default ActionsReportSchedule